import { useEffect, useRef } from 'react'
import { usePrivy } from '@privy-io/react-auth'
import { cleanupPrivyShell, privyModalLooksOpen, stripStalePrivyShell, unlockPrivyDocument } from '@/lib/privyShellCleanup'

export const PrivyModalCleanup = () => {
  const { authenticated, ready } = usePrivy()
  const wasAuthenticated = useRef(false)

  useEffect(() => {
    if (!ready) return

    const justLoggedIn = authenticated && !wasAuthenticated.current
    wasAuthenticated.current = authenticated

    if (!authenticated) {
      document.body.classList.remove('mem-wallet-ready')
      return
    }

    const cleanup = () => {
      cleanupPrivyShell()
    }

    cleanup()

    // Wallet deep-links remount Privy UI asynchronously after return-to-browser.
    const delays = justLoggedIn ? [0, 200, 600, 1200, 2500, 5000, 8000] : [0, 400, 1200]
    const timers = delays.map((ms) => window.setTimeout(cleanup, ms))

    const observer = new MutationObserver(() => {
      if (!authenticated) return
      if (document.body.style.position === 'fixed' || document.documentElement.style.position === 'fixed') {
        unlockPrivyDocument()
      }
      if (document.body.classList.contains('mem-wallet-ready') && !privyModalLooksOpen()) {
        stripStalePrivyShell()
      }
    })
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style', 'class'],
      childList: true,
      subtree: true,
    })
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style', 'class'],
    })

    const onVis = () => {
      if (document.visibilityState === 'visible') cleanup()
    }
    const onFocus = () => cleanup()
    document.addEventListener('visibilitychange', onVis)
    window.addEventListener('focus', onFocus)
    window.addEventListener('pageshow', onFocus)

    return () => {
      timers.forEach((id) => window.clearTimeout(id))
      observer.disconnect()
      document.removeEventListener('visibilitychange', onVis)
      window.removeEventListener('focus', onFocus)
      window.removeEventListener('pageshow', onFocus)
    }
  }, [ready, authenticated])

  return null
}
